import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useFela } from 'react-fela';
import { formatHhMmSsShort } from '../../utils';
import { Row, Text } from '../../common';
import AdLink from '../../ControlBar/AdInfo/AdLink';
import ControlContainer from '../../ControlBar/AdInfo/ControlContainer';
import SkipNextIcon from '../../ControlBar/AdInfo/SkipNextIcon';
import { usePlayer } from '../../../PlayerContext';

const rules = ({ theme }) => ({
  position: 'absolute',
  left: '0.5rem',
  right: '0.7rem',
  zIndex: 1,
  bottom: theme.margin.medium,
});

function AdControl() {
  const player = usePlayer();
  const {
    adSkipCountdown,
    adHasLink,
  } = useSelector(({ playback }) => ({
    adSkipCountdown: playback.adSkipCountdown,
    adHasLink: playback.adHasLink,
  }), shallowEqual);
  const { css } = useFela();

  const skip = () => {
    player.skip();
  };

  const openAdWebsite = () => {
    player.openAdWebsite();
  };

  return (
    <div className={css(rules)}>
      <Row alignCenter justifyContent={adHasLink ? 'space-between' : 'end'}>
        {adHasLink && (
          <AdLink onClick={openAdWebsite} mini />
        )}
        {adSkipCountdown >= 0 && (
          <ControlContainer onClick={skip} disabled={adSkipCountdown > 0} mini>
            {adSkipCountdown > 0 ? (
              <Text id="skipAdInTime" values={{ time: formatHhMmSsShort(adSkipCountdown) }} bold />
            ) : (
              <>
                <Text id="skipAd" bold />
                <SkipNextIcon width={19} height={19} />
              </>
            )}
          </ControlContainer>
        )}
      </Row>
    </div>
  );
}

export default React.memo(AdControl);
